import { Component, OnInit } from '@angular/core';
import { MatDialog} from '@angular/material';
import {AddPopupComponent} from '../Popups/add-popup/add-popup.component';
import { MobileNavService } from '../../shared/services/mobile-nav.service';
import {Location} from '@angular/common';

@Component({
  selector: 'app-customer-list',
  templateUrl: './customer-list.component.html',
  styleUrls: ['./customer-list.component.css']
})
export class CustomerListComponent implements OnInit {

 constructor(public dialog: MatDialog,private _location: Location,
               public mobileNav: MobileNavService) { }

  openDialog(): void {
    let dialogRef = this.dialog.open(AddPopupComponent, {
      width: '450px'
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });
  }

  onClickMe() {
        this.mobileNav.showSideNav();
    }

  ngOnInit(){}


  backBtnClick(){
    this._location.back();
  }
}